var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.farms.length > 0)?_c('Dropdown',{attrs:{"options":_vm.farms,"disabled":_vm.disabled,"textValue":_vm.displayValue},on:{"select":_vm.selectFarm}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }